/**
 * Created by don on 7/27/15.
 */
'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var FeeStructure = module.exports = SoaModel.extend();
var endpoints = require('dibs-endpoints');
var _ = require('underscore');

/**
 * Contains information about dealer fee structures.
 * Used to change which fee structure a dealer is associated with.
 * @class FeeStructure
 * @extends SoaModel
 *
 */
_.extend(FeeStructure.prototype, {

    url: function () {
        return endpoints.feeStructure(this.id);
    },

    initialize: function (attrs, options) {
        this.id = options.id;
    }

});

_.extend(FeeStructure, {
    TYPE: {
        TIERED: 'TIERED',
        FLAT_RATE_10: 'FLAT_RATE_10',
        FLAT_RATE_20: 'FLAT_RATE_20',
        FLAT_RATE_22: 'FLAT_RATE_22',
        FLAT_RATE_37: 'FLAT_RATE_37'
    },
    feeStructureIds: {
        TIERED: 2201,
        FLAT_RATE_10: 2202,
        FLAT_RATE_20: 2203,
        FLAT_RATE_22: 2206,
        FLAT_RATE_37: 2207
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/FeeStructure.js
// module id = 2044
// module chunks = 63